export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    width: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    width: 300,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displaySpec') || '颜色/尺寸/花型/款式/入数',
    field: 'displaySpec',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySpec' },
  },
  {
    title: that.$l('table_label_displayBrandCategory') || '品牌/分类',
    field: 'displayBrandCategory',
    width: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBrandCategory' },
  },
  {
    title: that.$l('table_label_displayScm') || '生产工厂',
    field: 'displayScm',
    width: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScm' },
  },
  {
    title: that.$l('table_label_designName') || '企划人员',
    field: 'designName',
    width: 140,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_buyerName') || '采购人员',
    field: 'buyerName',
    width: 140,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_materialInfo') || '材料信息',
    field: 'materialInfo',
    width: 340,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_materialInfoEn') || '英文材料信息',
    field: 'materialInfoEn',
    width: 340,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayGoodsSpec') || '产品规格',
    field: 'displayGoodsSpec',
    width: 240,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayGoodsSpec' },
  },
  {
    title: that.$l('table_label_displayUnitSpec') || '包装规格',
    field: 'displayUnitSpec',
    width: 240,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayUnitSpec' },
  },
  {
    title: that.$l('table_label_displayCtnSpec') || '纸箱规格',
    field: 'displayCtnSpec',
    width: 240,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCtnSpec' },
  },
  {
    title: that.$l('table_label_displayHscode') || 'HSCODE',
    field: 'displayHscode',
    width: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayHscode' },
  },
]
